import { render, staticRenderFns } from "./addCourseBox.vue?vue&type=template&id=7d55e856"
import script from "./addCourseBox.vue?vue&type=script&lang=js"
export * from "./addCourseBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports